import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import Slider from 'components/common/Slider/Slider';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const SubmittedCompletion = ({ isSelected, onFiltersChanged }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Submitted Completion</span>
            <div className={classes.sliderWrapper}>
                <Controller
                    render={({ field }) => (
                        <Slider
                            id={'battlecards-filters-submittedCompletion-slider'}
                            {...field}
                            step={10}
                            min={0}
                            max={100}
                            valueLabelDisplay={'on'}
                            onChangeCommitted={(_e, value) => {
                                onFiltersChanged({ [field.name]: value });
                            }}
                        />
                    )}
                    name={'submittedCompletion'}
                    control={control}
                />
            </div>
        </div>
    ) : null;
};
